module.exports = __webpack_public_path__ + "img/leilanie-higgins.8bbd2d74.png";